const $ = require('jquery');

export default {
  init() {
    const drawerHandler = () => {
      $('#drawer-toggler').toggleClass('is-active');
      $('#drawer').toggleClass('is-open');
      $('body').toggleClass('drawer-open');
      if ($('#drawer-toggler').hasClass('is-active')) {
        $('#drawer-toggler')
          .find('.js-menu-label')
          .html($('#drawer-toggler').data('opened-text'));
      } else {
        $('#drawer-toggler')
          .find('.js-menu-label')
          .html($('#drawer-toggler').data('closed-text'));
      }
    };

    $('#drawer-toggler').on('click', (e: any) => {
      drawerHandler();
    });

    $('.js-backdrop').on('click', (e: any) => {
      drawerHandler();
    });
  }
};
